import script from "./info-list.vue?vue&type=script&setup=true&lang=js"
export * from "./info-list.vue?vue&type=script&setup=true&lang=js"

import "./info-list.vue?vue&type=style&index=0&id=541ba997&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541ba997"]])

export default __exports__